import _regeneratorRuntime from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0bc853eb"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "confirm-dialog"
};
import info from '@/api/info';
import { $formErr, $getInfo } from '@/assets/common/common.js';
import googleRelieve from '@/assets/image/google-relieve.png';
import mailRelieve from '@/assets/image/mail-relieve.png';
import phoneRelieve from '@/assets/image/phone-relieve.png';
import wxRelieve from '@/assets/image/wx-relieve.png';
import { useLang } from '@/hooks/lang';
import { XlButton, XlDialog, XlMessage } from '@shining3d/ui-components';
import { VueCookieNext } from 'vue-cookie-next';
export default {
  props: {
    typeConfirm: String,
    openId: String
  },
  emits: ['successOut'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emits = _ref.emit;
    var props = __props;
    var _useLang = useLang('@shining3d/app'),
      $t = _useLang.$t;
    var infoText = ref('');
    if (props.typeConfirm === 'wechat') {
      infoText.value = $t('personalInformation.passWord.unWx');
    } else if (props.typeConfirm === 'phone') {
      infoText.value = $t('personalInformation.passWord.unPhone');
    } else if (props.typeConfirm === 'email') {
      infoText.value = $t('personalInformation.passWord.unMail');
    } else {
      infoText.value = $t('personalInformation.passWord.unGoogle');
    }
    var dialogVisible = ref(false);
    var submitLoading = ref(false);
    var closeDialog = function closeDialog() {
      dialogVisible.value = false;
    };
    var submit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              res = '';
              submitLoading.value = true;
              if (!(props.typeConfirm === 'wechat' || props.typeConfirm === 'google')) {
                _context.next = 8;
                break;
              }
              _context.next = 5;
              return info.unBindOauth({
                loginType: props.typeConfirm,
                openId: props.openId,
                platform: 'productCloud'
              });
            case 5:
              res = _context.sent;
              _context.next = 11;
              break;
            case 8:
              _context.next = 10;
              return info.unBindSilde(VueCookieNext.getCookie('user_id'), props.typeConfirm);
            case 10:
              res = _context.sent;
            case 11:
              if (res.status === 'success') {
                XlMessage({
                  type: 'success',
                  message: $t('messages.successEdit')
                });
                $getInfo();
                closeDialog();
                emits('successOut');
              } else {
                $formErr(res.result, {}, 'msg');
              }
              submitLoading.value = false;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function submit() {
        return _ref2.apply(this, arguments);
      };
    }();
    expose({
      dialogVisible: dialogVisible
    });
    return function (_ctx, _cache) {
      var _component_el_image = _resolveComponent("el-image");
      var _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(XlDialog), {
        "destroy-on-close": "",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return dialogVisible.value = $event;
        }),
        class: "messageDialog",
        width: "340px",
        "before-close": closeDialog
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_row, {
            class: "infoBox"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_row, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_image, {
                    class: "titleimage",
                    src: props.typeConfirm === 'phone' ? _unref(phoneRelieve) : props.typeConfirm === 'email' ? _unref(mailRelieve) : props.typeConfirm === 'wechat' ? _unref(wxRelieve) : _unref(googleRelieve),
                    fit: _ctx.fit
                  }, null, 8, ["src", "fit"])];
                }),
                _: 1
              }), _createVNode(_component_el_row, null, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref($t)("personalInformation.passWord.unBinding")), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_row, null, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(infoText.value), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "footer"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlButton), {
                loading: submitLoading.value,
                onClick: submit
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref($t)("button.determine")), 1)];
                }),
                _: 1
              }, 8, ["loading"]), _createVNode(_unref(XlButton), {
                type: "primary",
                onClick: closeDialog
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref($t)("button.cancel")), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};